export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_00.d8a24f11.jpg";